import { render, staticRenderFns } from "./AttendeeEditTabSocial.vue?vue&type=template&id=a34cc462&"
import script from "./AttendeeEditTabSocial.vue?vue&type=script&lang=js&"
export * from "./AttendeeEditTabSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports